<template>
    <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="languageDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img :src="computeIconUrl">
            {{ computeCurrentName }}
        </button>
        <div class="dropdown-menu" aria-labelledby="languageDropdown">    
            <a class="dropdown-item" v-for="lang in languages" @click="setLanguage(lang.code)" :key="lang.code" >
                <span>
                    <img :src="`${publicPath}flagIcons/${lang.code}.png`" :key="lang.code" >
                </span>
                {{ lang.name }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LanguageSelector',
    methods: {
        setLanguage: function(code) {
            this.current = code;
        }
    },
    computed: {
        current: {
            get() {
                return this.$i18n.locale;
            }, set(val) {
                this.$store.commit('setLocale', val)
                this.$i18n.locale = val;
            }
        },
        currentLanguage: function() {
            return this.languages.find(el => el.code === this.current);
        },
        computeIconUrl: function() {
            if (this.isUndefined(this.currentLanguage)) {
                return "";
            }
            return `${this.publicPath}flagIcons/${this.currentLanguage.code}.png`
        },
        computeCurrentName: function() {
            if (this.isUndefined(this.currentLanguage)) {
                return "";
            }
            return this.currentLanguage.name;
        },
        languages: function() {
            let fullNameLocale = {
                en: "English",
                de: "Deutsch",
                fr: "Français",
                it: "Italiano"
            }

            return this.$i18n.availableLocales.map(loc => {
                return {
                    code: loc,
                    name: fullNameLocale[loc]
                }
            });
        },
    },
    mounted() {
        if (this.current === undefined) {
            console.log("Locale is undefined, setting it to DE")
            this.setLanguage('de');
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }

}
</script>

<style lang="scss" scoped>

    #languageDropdown {
        background-color: white !important;
        color: $primary-color;
        padding: 15px;
        min-width: 100%;
    }

    .dropdown-menu {
        width: 100%;
    }

    .dropdown-item {
        color: $primary-color !important;
        padding: 15px;
        text-align: left;
        height: 100%;
    }

    .dropdown-item:hover {
        cursor: pointer;
        background-color: $primary-color;
        color: white !important;
    }

    .dropdown {
        width: 100%
    }
</style>